import { Injectable, inject } from '@angular/core';
import { TwcRefreshLayerPluginService } from '../../../twc.refresh-layer-plugin.service';
import { TURBULENCE_LEGEND } from './turbulence.legend';
import { TURBULENCE_PRODUCT_DATA } from './turbulence.twc-product-data';

@Injectable({
  providedIn: 'root'
})
export class TurbulencePluginService {
  private readonly _twcPluginService = inject(TwcRefreshLayerPluginService);
  plugin$ = this._twcPluginService.create(TURBULENCE_PRODUCT_DATA, {
    legend: TURBULENCE_LEGEND,
    twcLayerTypes: ['web-tile']
  });
}
